import { PRICING } from '../types'

export const pricingReducer = (state = {}, action) =>{
  const {type, payload} = action

  switch (type) {
    case PRICING: {
      const { data } = payload
      return data
    }
    
    default: {
      return state
    }
  }
}
